import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";
import "./cancelOrderDialog.scss";
import orderStore from "store/orderStore";
import snackbarStore from "store/snackbarStore";
import SnackbarAlert from "components/snackbarAlert/snackbarAlert";
import { LoadingButton } from "@mui/lab";

const CancelOrderDialog = ({ setOpenDialog, openDialog, myOrderDetails }) => {
  const order_cancel_reasons = [
    "Item is no longer needed",
    "Duplicate order",
    "Found a better price",
    "Changed my mind",
    "Other",
  ];

  const OrderStore = orderStore();
  const SnackbarStore = snackbarStore();

  const [isLoading, setIsLoading] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [selectedCancelReason, setSelectedCancelReason] = useState("");
  const [otherReason, setOtherReason] = useState("");

  const handleOrderCancel = async () => {
    setIsLoading(true);
    console.log(myOrderDetails);
    const success = await OrderStore.cancelOrder({
      orderId: myOrderDetails?._id,
      reason:
        selectedCancelReason === "Other" ? otherReason : selectedCancelReason,
    });

    if (success) {
      setAlertSeverity("success");
      SnackbarStore.setMassage({ value: "Order Cancelled Successfully" });
      SnackbarStore.setIsOpen({ value: true });
      setOpenDialog(false);
      setSelectedCancelReason("");
      setOtherReason("");
    } else {
      SnackbarStore.setMassage({ value: "Failed to Cancel Order" });
      SnackbarStore.setIsOpen({ value: true });
      setAlertSeverity("error");
    }
    setIsLoading(false);
  };

  return (
    <>
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        // alertVariant="filled"
        alertSeverity={alertSeverity}
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
        }}
        massage={SnackbarStore.massage}
      />
      <Dialog
        open={isLoading || openDialog}
        onClose={() => setOpenDialog(false)}
        className="cancel-order-confirm-dialog"
      >
        <DialogTitle>
          <Stack spacing={2} className="dialog-title">
            <p className="dialog-title">Order Cancel Confirmation</p>
          </Stack>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <p className="desc">Are you sure you want to cancel this order?</p>

          <Stack spacing={2} className="payment-mode">
            <p className="label">Order Amount Refund Policy</p>
            <p className="description">
              If COD, the amount will not be credited. If Online Payment (UPI,
              Card, Net Banking, Wallet), the amount will be refunded to your
              original payment method within 5–7 working days.
            </p>
          </Stack>

          <Stack spacing={1} className="reason">
            <p className="label">Reason for Cancellation</p>
            <Stack spacing={1} className="radio-items">
              {order_cancel_reasons?.map((reason, idx) => (
                <FormControlLabel
                  key={idx}
                  control={
                    <Radio
                      checked={selectedCancelReason === reason}
                      onChange={(event) =>
                        setSelectedCancelReason(event.target.value)
                      }
                      value={reason}
                      name="reason-radio"
                    />
                  }
                  label={reason}
                  className="reason-label"
                />
              ))}
              {selectedCancelReason === "Other" && (
                <Stack spacing={1} className="other-reason">
                  <TextField
                    value={otherReason}
                    onChange={(event) => setOtherReason(event.target.value)}
                    multiline
                    rows={4}
                    placeholder="Enter your reason..."
                    className="other-reason-input"
                  />
                </Stack>
              )}
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            className="btn"
            onClick={() => {
              setOpenDialog(false);
              setSelectedCancelReason("");
            }}
          >
            No
          </Button>
          <LoadingButton
            loading={isLoading}
            className="btn yes"
            disabled={!selectedCancelReason}
            onClick={() => {
              handleOrderCancel();
            }}
          >
            Yes
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CancelOrderDialog;
